import { FileQuestionIcon } from "lucide-react";

const VariablesInstructionCard = () => {
  return (
    <div className="w-full my-4 max-w-xl mx-auto border-t-8 border-t-blue-700 bg-blue-50 border border-blue-200 rounded-2xl p-5 space-y-4">
      <h3 className="text-lg font-semibold text-blue-800 flex items-center gap-2">
        <FileQuestionIcon />
        How to Use Custom Variables
      </h3>

      <div className="text-sm text-blue-900 space-y-2">
        <p>
          You can personalize your email by using variables inside your subject
          or email body.
        </p>

        <p>Use double curly brackets like this:</p>

        <div className="bg-white border border-blue-200 rounded-lg p-3 font-mono text-sm">
          {"{{custom_offer}}"} <br />
          {"{{expiry_date}}"}
        </div>

        <p>
          When sending the email, these placeholders will be replaced with the
          values you define below.
        </p>

        <div className="bg-white border border-blue-200 rounded-lg p-3 text-sm">
          <p className="font-semibold mb-1">Example:</p>

          <p className="mb-1">
            Subject:{" "}
            <span className="font-mono">
              Special Offer: {"{{custom_offer}}"}
            </span>
          </p>

          <p>If you set:</p>

          <div className="font-mono text-xs mt-2 bg-gray-50 p-2 rounded">
            custom_offer = 20% Discount
          </div>

          <p className="mt-2">The final email will show:</p>

          <div className="font-mono text-xs mt-2 bg-green-50 p-2 rounded border border-green-200">
            Special Offer: 20% Discount
          </div>
        </div>

        <div className="text-xs text-blue-700 mt-2">
          ⚠️ Variable names are case-sensitive. Make sure the key matches
          exactly.
        </div>
      </div>
    </div>
  );
};

export default VariablesInstructionCard;
